import { process } from '../ResizeObserverController';
import { prettifyConsoleOutput } from './prettify';
const CATCH_FRAMES = 60 / 5;
const requestAnimationFrame = window.requestAnimationFrame;
const observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
const events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
const rafSlot = new Map();
const resizeObserverSlot = new Map();
let scheduled;
const dispatchCallbacksOnNextFrame = () => {
    if (scheduled) {
        return;
    }
    scheduled = true;
    function runSchedule(t) {
        scheduled = false;
        const frameCallbacks = [];
        const resizeObserverCallbacks = [];
        rafSlot.forEach(callback => frameCallbacks.push(callback));
        resizeObserverSlot.forEach(callback => resizeObserverCallbacks.push(callback));
        rafSlot.clear();
        resizeObserverSlot.clear();
        try {
            for (let callback of frameCallbacks) {
                callback(t);
            }
        }
        finally {
            for (let callback of resizeObserverCallbacks) {
                callback(t);
            }
        }
    }
    ;
    requestAnimationFrame(runSchedule);
};
class Scheduler {
    constructor() {
        this.stopped = true;
        this.listener = () => this.schedule();
    }
    run(frames) {
        const scheduler = this;
        resizeObserverSlot.set(this, function ResizeObserver() {
            let elementsHaveResized = false;
            try {
                elementsHaveResized = process();
            }
            finally {
                if (elementsHaveResized) {
                    scheduler.run(60);
                }
                else if (frames) {
                    scheduler.run(frames - 1);
                }
                else {
                    scheduler.start();
                }
            }
        });
        dispatchCallbacksOnNextFrame();
    }
    schedule() {
        this.stop();
        this.run(CATCH_FRAMES);
    }
    observe() {
        const cb = () => this.observer && this.observer.observe(document.body, observerConfig);
        document.body ? cb() : window.addEventListener('DOMContentLoaded', cb);
    }
    start() {
        if (this.stopped) {
            this.stopped = false;
            if ('MutationObserver' in window) {
                this.observer = new MutationObserver(this.listener);
                this.observe();
            }
            events.forEach(name => window.addEventListener(name, this.listener, true));
        }
    }
    stop() {
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(name => window.removeEventListener(name, this.listener, true));
            this.stopped = true;
        }
    }
}
const scheduler = new Scheduler();
let rafIdBase = 0;
window.requestAnimationFrame = function (callback) {
    if (typeof callback !== 'function') {
        throw new Error('requestAnimationFrame expects 1 callback argument of type function.');
    }
    const handle = rafIdBase += 1;
    rafSlot.set(handle, function AnimationFrame(t) { return callback(t); });
    dispatchCallbacksOnNextFrame();
    return handle;
};
window.cancelAnimationFrame = function (handle) {
    rafSlot.delete(handle);
};
prettifyConsoleOutput(window.requestAnimationFrame);
prettifyConsoleOutput(window.cancelAnimationFrame);
export { scheduler };
